<template>
    <div >
      <Card>
            <p slot="title">
                Failed Invoicing
            </p>
                <template>
                        <Table border :columns="columnTableInvoice" :data="itemInvoice"></Table>
                </template>
        </Card>

        <template>
            <Modal v-model="modal.editItemInvoice" @on-ok="updateIsActive" width="500px">
              <Form ref="formeditItemInvoice" :model="formeditItemInvoice">
                <Input style="display: none" v-model="formeditItemInvoice.id" placeholder="Invoice ID"></Input>
              </Form>
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Re-Invoicing</span>
                </p>
                <p>Anda yakin ingin Re-Invoicing Invoice ID : {{ this.formeditItemInvoice.id }} ?</p>
            </Modal>

        </template>
    </div>
</template>
<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'

export default {
    data () {
        return {


        user : {
            username : '',
            role : ''
        },
        modal : {
            createitemInvoice : false,
            editItemInvoice : false,
        } ,
        loadingSearch: false,
        loadingCreateitemInvoice: false,
        loadingeditItemInvoice: false,
        itemInvoice : [],
        formeditItemInvoice: {
            deptName: '',
        },
        ruleValidate: {
            deptName: [
                { required: true, message: 'Masukkan Dept Name', trigger: 'blur' }
            ],
        },
        columnTableInvoice: [
            {
                title: 'Invoice ID',
                key: 'invoiceid'
            },
            {
                title: 'Created Date',
                key: 'createddtm'
            },
            {
                title: 'Invoice Date',
                key: 'invoicedate'
            },
            {
                title: 'Invoice Fee',
                key: 'invoicefee'
            },
            {
                title: 'Dept Name',
                key: 'deptName'
            },
            {
                title: 'Marking Code',
                key: 'markingcode'
            },
            {
                title: 'Container Code',
                key: 'containercode'
            },
            {
                title: 'Load Date',
                key: 'loaddate'
            },
            {
                title: 'Action',
                key: 'action',
                width: 180,
                align: 'center',
                render: (h, params) => {
                    let buttonToShow = [
                             h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.show(params.index)
                                    }
                                }
                            }, 'Re-Invoicing')
                    ];


                    return h('div', buttonToShow);
                }
            }
        ],
    }},

  methods: {
    show: function(index){
        var editItemInvoiceId = this.itemInvoice[index].invoiceid;
        this.formeditItemInvoice.id = editItemInvoiceId;

        //console.log(this.itemInvoice[index].id);
        this.modal.editItemInvoice = true;
    },
    postInvoiceUpdate: function(){
        HTTP
        .post('invoice/setReInvoice', {
            id: this.formeditItemInvoice.id,
        })
        .then(response => {
            this.$Message.success('Invoice Updated!');
            this.getInvoice();
        })
        .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc:e,
                duration: 5
            });
        })
    },
    getInvoice: function(){
        this.loadingSearch  = true;
        this.itemInvoice = []
        HTTP
            .get('failedInvoice')
            .then(response => {
                this.loadingSearch  = false;
                this.itemInvoice = response.data
            })
            .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
        })
    },
    updateIsActive: function() {
        this.postInvoiceUpdate();
    }
  },
  created() {
      this.user.username = localStorage.getItem('user.username')
      this.user.role = localStorage.getItem('user.role')
      this.getInvoice();
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// FailedInvoicing.vue?6afd9175